import React, { useState, useEffect } from "react";
import { PageHeader } from "components/ui";
import {
  Grid,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";
import GriStandardsSelector from "components/customizedStandardsComponent/GriStandardsSelector";
import GriFormComponent from "components/customizedStandardsComponent/GriFormComponent";
import UploadEvidenceComponent from "components/customizedStandardsComponent/UploadEvidenceComponent";
import DownloadReport from "components/customizedStandardsComponent/DownloadReport";
import DownloadPostReviewGapForm from "components/customizedStandardsComponent/DownloadPostReviewGapForm";
import UploadPostReviewGapForm from "components/customizedStandardsComponent/UploadPostReviewGapForm";
import DownloadPostReviewReports from "components/customizedStandardsComponent/DownloadPostReviewReports";

import StandardsSelector from "components/customizedStandardsComponent/GriStandardsSelector";
import NavigationButtons from "helper/navigation/NavigationButtons";
import ReusableFormComponent from "components/customizedStandardsComponent/EsgFormComponent";
import { ENV_SOCIAL_MANAGEMENT_PLANS } from "data/standards/griStandards";
import { E_S_PLAN_PROCEDURE_WORK_INS_FORM } from "data/forms/griFormSchema";
import {
  enviromentalSocialSystemDevData,
  enviromentalSocialSystemDocuments,
  finalizedCleanDocuments,
  reviewAndCommentDocuments,
  reviewDocumentsDownloadGeneratedReports,
} from "data/reports/relevantReports";
import ReportsReviewDialog from "components/customizedStandardsComponent/ReportsReviewDialog";
import UploadEvidenceReviewReports from "components/customizedStandardsComponent/UploadEvidenceReviewReports";

const EsSocialSystemDevelopment = () => {
  const [activeStep, setActiveStep] = useState(0);
  const [prevStep, setPrevStep] = useState(0);
  const [reportData, setReportData] = useState({
    selectedStandards: [],
    companyInfo: {},
  });
  const [showReviewPopup, setShowReviewPopup] = useState(false);

  const steps = [
    "Select Environmental and Social Management Plans Standards",
    "Download Environmental and Social Management Plans Report",
    "Fill Environmental and Social Management Plans Form",
    "Download Generated Documents",
    "Download Environmental and Social Management Plans Documents",
    "Review and Comment on Environmental and Social Management Plans",
    "Download Finalized Clean Documents",
  ];

  // useEffect(() => {
  //     if (activeStep === 4 && prevStep === 3) {
  //         setShowReviewPopup(true);
  //     }
  // }, [activeStep, prevStep]);

  const handleNext = () => {
    setPrevStep(activeStep);
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setPrevStep(activeStep);
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleSaveStandards = (selectedStandards) => {
    setReportData((prev) => ({
      ...prev,
      selectedStandards,
    }));
    console.log("Standards saved:", selectedStandards);
  };

  const handleClosePopup = () => {
    setShowReviewPopup(false);
  };

  const handleSkipToStep5 = () => {
    setPrevStep(activeStep);
    setActiveStep(5);
    setShowReviewPopup(false);
  };

  const getStepContent = (step) => {
    switch (step) {
      case 0:
        return (
          <StandardsSelector
            standards={ENV_SOCIAL_MANAGEMENT_PLANS}
            onNext={handleNext}
            onSave={handleSaveStandards}
            title="Select the Plans, Procedures, and Work Instructions to Develop"
            nextButtonText="Next"
            initialSelectedStandards={reportData.selectedStandards.map(
              (s) => s.id
            )}
          />
        );
      case 1:
        return (
          <DownloadReport
            key="environmental-social-system-step"
            onPrevious={handleBack}
            onNext={handleNext}
            initialItems={enviromentalSocialSystemDevData}
            title="Provide Relevant Data and Information."
            ReportDownloadButtonShow={false}
          />
        );
      case 2:
        return (
          <ReusableFormComponent
            {...E_S_PLAN_PROCEDURE_WORK_INS_FORM}
            onNext={handleNext}
            onPrevious={handleBack}
            showPreviousButton={true}
          />
        );
      case 3:
        return (
          <DownloadReport
            onPrevious={handleBack}
            onNext={handleNext}
            initialItems={enviromentalSocialSystemDocuments}
            title="Upload Documents"
            ReportDownloadButtonShow={false}
          />
        );
      case 4:
        return (
          <DownloadReport
            key="review-and-comment-step"
            onPrevious={handleBack}
            onNext={handleNext}
            initialItems={reviewDocumentsDownloadGeneratedReports}
            title=""
          />
        );
      case 5:
        return (
          <DownloadReport
            key="review-and-comment-step"
            onPrevious={handleBack}
            onNext={handleNext}
            initialItems={reviewAndCommentDocuments}
            title="Upload reviewed documents with comments"
            ReportDownloadButtonShow={false}
            uploadEvidenceFieldsShow={true}
          />
        );
      case 6:
        return (
          <DownloadReport
            key="finalized-clean-documents-step"
            onPrevious={handleBack}
            initialItems={finalizedCleanDocuments}
            NextButtonShow={false}
            showReportCountdownButton={true}
          />
        );
      default:
        return "Unknown step";
    }
  };

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
            <PageHeader title="AI-Powered ESG Reporting across Global, National, Sectoral, and Industry-Specific Standards" />
          </Box>
          <Grid item xs={12}>
            <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
              <NavigationButtons
                imageKey="dashboardImg3_7"
                title={"Environmental & Social System Development"}
                activeStep={activeStep}
                onBack={handleBack}
              />
            </Box>
          </Grid>
        </Grid>

        <Grid item xs={12}>
          {getStepContent(activeStep)}
        </Grid>

        <Grid item xs={12}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              mt: 4,
              mb: 2,
            }}
          ></Box>

          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              mt: -1,
            }}
          >
            {steps.map((_, index) => (
              <Box
                key={index}
                sx={{
                  width: 10,
                  height: 10,
                  borderRadius: "50%",
                  backgroundColor: index <= activeStep ? "#02462E" : "#e0e0e0",
                  mx: 1,
                }}
              />
            ))}
          </Box>
        </Grid>
      </Grid>

      <ReportsReviewDialog
        open={showReviewPopup}
        onClose={handleClosePopup}
        onSkip={handleSkipToStep5}
      />
    </>
  );
};

export default EsSocialSystemDevelopment;
